import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { CustomScrollbar, noTextSelect } from '../../common/CssCommon';
import Dialog from '../Dialog';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../store/modules/dialog';
import ActiveLinkDialogFooter from './ActiveLinkDialogFooter';
import InputSearch from '../../common/InputSearch';
import { useState } from 'react';
import axios from 'axios';
import ga from '../../../utils/gaConnect';

import IconYoutube from '../../../img/activeLink/ribbonIcon/ribbon_big_ico_youtube.png';
import IconYoutube2x from '../../../img/activeLink/ribbonIcon/ribbon_big_ico_youtube@2x.png';
import { insertActiveLink } from '../../plugin/activeLink';
import { usePOWebofficeSDKState } from '../../../context/poWebOfficeSDKContext';
import TextInput from '../../common/TextInput';
import { URLS } from '../../../define/global';

// const DialogBody = styled.div`
//   display: flex;
//   flex-flow: column;
//   width: 970px;
//   padding: 16px 16px 0px 16px;
//   ${noTextSelect}
// `;

const DialogBody = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  width: 568px;
  padding: 16px 16px 0px 16px;
  ${noTextSelect}
`;

const InputArea = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  flex-flow: row;

  padding: 0px 4px;
`;

const InputStringWrapper = styled.div`
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f3133;
`;

const TextInputWrapper = styled.div`
  flex: 1;
  margin-left: 17px;
`;

const SubTextArea = styled.div`
  width: 470px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  padding: 5px 4px 0px;
`;

const Warning = styled.div`
  flex: 1;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #f33;
`;

const Guide = styled.a`
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #1d7ff9;
`;

const FooterWrapper = styled.div`
  padding: 18px 20px;
`;

// const InputSearchArea = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;

// const SearchResultArea = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   align-content: flex-start;

//   margin-top: 16px;
//   gap: 8px;
//   padding: 3px;

//   width: 100%;
//   height: 390px;

//   overflow-y: scroll;

//   ${CustomScrollbar};
// `;

// const YoutubeItem = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;

//   ${({ selected }) =>
//     selected &&
//     css`
//       outline: solid 2px #1d7ff9;
//     `}
// `;

// const EmptyResult = styled.div`
//   width: 100%;
//   height: 100%;

//   display: flex;
//   justify-content: center;

//   font-size: 14px;
//   font-weight: normal;
//   font-stretch: normal;
//   font-style: normal;
//   line-height: normal;
//   letter-spacing: normal;
//   color: #2f3133;
// `;

export default function ActiveLinkYoutube({ isShow }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const poSDKContextState = usePOWebofficeSDKState();

  // const [search, setSearch] = useState('');
  // const [items, setItems] = useState([]);
  // const [selected, setSelected] = useState();
  const [url, setUrl] = useState('');
  const [warning, setWarning] = useState(null);

  const onDialogClose = () => dispatch(closeDialog());

  // const reqUrl = `https://www.googleapis.com/youtube/v3/search?part=snippet`;
  const YOUTUBE_PLAY = 'https://www.youtube.com/embed';
  // const MAX_RESULT_COUNT = 50;

  // const onSearch = async (search) => {
  //   try {
  //     const res = await axios.get(
  //       `${reqUrl}&maxResults=${MAX_RESULT_COUNT}&q=${encodeURI(search)}&key=${
  //         process.env.REACT_APP_YOUTUBE_API_KEY
  //       }`
  //     );
  //     const resItems = res?.data?.items || [];
  //     const items = resItems
  //       .filter((item) => item.id.videoId && item.snippet.thumbnails.default.url)
  //       .map((item) => ({
  //         id: item.id.videoId,
  //         thumbUrl: item.snippet.thumbnails.default.url
  //       }));

  //     setItems(items);
  //   } catch (err) {
  //     setItems([]);
  //   }
  // };

  // const onInsertYoutube = async () => {
  //   try {
  //     const targetUrl = `${YOUTUBE_PLAY}/${selected}`;
  //     ga.event({ category: '액티브링크', action: '콘텐츠추가', label: '유튜브' });
  //     await insertActiveLink(poSDKContextState, targetUrl);
  //     onDialogClose();
  //   } catch (error) {
  //     ga.event({ category: '액티브링크', action: '추가실패', label: '유튜브' });
  //     onDialogClose();
  //   }
  // };
  const getSrcUrl = (url) => {
    try {
      const _url = new URL(url);
      const src =
        (_url.origin.includes('youtube.com') && _url.searchParams.get('v')) ||
        (_url.origin.includes('youtu.be') && _url.pathname.split('/')[1]);
      return src;
    } catch (err) {
      return null;
    }
  };
  const onInsertYoutube = async (url) => {
    const src = getSrcUrl(url);
    if (src) {
      ga.event({ category: '액티브링크', action: '콘텐츠추가', label: '유튜브' });
      await insertActiveLink(poSDKContextState, `${YOUTUBE_PLAY}/${src}`);
      onDialogClose();
    } else {
      ga.event({ category: '액티브링크', action: '추가실패', label: '유튜브' });
      const warningText = t('ActiveLink.InvalidUrl');
      setWarning(warningText);
    }
  };

  return (
    <Dialog
      icon={IconYoutube}
      icon2x={IconYoutube2x}
      title={t('ActiveLink.YouTube')}
      showTitleSeperateLine={true}
      showCloseBtn
      onClickCloseBtn={onDialogClose}
      isShow={isShow}>
      <DialogBody>
        <InputArea>
          <InputStringWrapper>{t('ActiveLink.YouTube')} URL</InputStringWrapper>
          <TextInputWrapper>
            <TextInput
              value={url}
              placeholder={t('ActiveLink.InputUrl')}
              onChange={(e) => setUrl(e.target.value)}
              onSubmit={onInsertYoutube}
              autoFocus={true}></TextInput>
          </TextInputWrapper>
        </InputArea>
        <SubTextArea>
          {warning && <Warning>{warning}</Warning>}
          <Guide
            href={URLS.NOTION.ACTIVELINK_INSERT_YOUTUBE_GUIDE}
            target="_blank"
            onClick={() => {
              ga.event({ category: '액티브링크', action: '가이드보기', label: '유튜브' });
            }}>
            {t('ActiveLink.DirectGuide')}
          </Guide>
        </SubTextArea>
        {/* <InputSearchArea>
          <InputSearch
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onSearch={onSearch}
            placeholder={t('Common.InputSearchText')}></InputSearch>
        </InputSearchArea>
        <SearchResultArea>
          {items && items.length > 0 ? (
            items.map((item) => (
              <YoutubeItem
                key={item.id}
                value={item.id}
                selected={item.id === selected}
                onClick={() => setSelected(item.id)}>
                <img width="230px" height="130px" src={`${item.thumbUrl}`} alt=""></img>
              </YoutubeItem>
            ))
          ) : (
            <EmptyResult>{t('ActiveLink.NotSearchResult')}</EmptyResult>
          )}
        </SearchResultArea> */}
      </DialogBody>
      <FooterWrapper>
        <ActiveLinkDialogFooter onSubmit={() => onInsertYoutube(url)}></ActiveLinkDialogFooter>
      </FooterWrapper>
    </Dialog>
  );
}
